module.exports = __webpack_public_path__ + "static/media/screen-blur.14d405bb.jpg";